
import { supabase } from '@/integrations/supabase/client';
import { RentalInfo, formatRental } from '../types/rentalTypes';
import { createMockRentals } from '../utils/courierUtils';
import { toast } from '@/components/ui/sonner';
import { updateSubscriptionStatus } from '@/pages/admin/rentals/services/subscriptionApi';

// Получает аренды для указанного курьера
export async function fetchCourierRentals(courierIdToUse: string): Promise<{
  formattedRentals: RentalInfo[];
  error: string | null;
}> {
  try {
    console.log("Запрашиваем аренды для курьера с ID:", courierIdToUse);
    
    const { data: rentalData, error: rentalError } = await supabase
      .from('rentals')
      .select(`
        id,
        bike_id,
        start_date,
        end_date,
        status,
        amount,
        human_number,
        documents_url,
        subscription_id,
        bikes (
          model
        )
      `)
      .eq('courier_id', courierIdToUse);
      
    if (rentalError) {
      console.error('Ошибка при получении аренд:', rentalError);
      throw rentalError;
    }
    
    console.log("Получены данные об аренде для курьера", courierIdToUse, ":", rentalData);
    
    if (!rentalData || rentalData.length === 0) {
      console.log("Нет данных об арендах в таблице rentals");
      return { formattedRentals: [], error: null };
    }
    
    const formattedRentals = rentalData.map(rental => formatRental(rental));
    console.log("Форматированные данные аренды:", formattedRentals);
    
    return { formattedRentals, error: null };
  } catch (err: any) {
    return { formattedRentals: [], error: err.message };
  }
}

// Создает тестовые данные для демонстрационного режима
export function createDemoRentals(): RentalInfo[] {
  const mockRentals = createMockRentals();
  
  const formattedRentals = mockRentals.map(rental => formatRental(rental));
  console.log("Созданы тестовые данные аренды:", formattedRentals);
  
  return formattedRentals;
}

// Показывает сообщение об ошибке
export function showErrorToast(message: string) {
  toast.error(message, {
    duration: 5000 // 5 секунд для уведомления
  });
}

// Отменяет подписки, связанные с арендой
export async function cancelSubscriptionsForRental(rentalId: string): Promise<{
  success: boolean;
  message: string;
}> {
  try {
    console.log('Проверяем подписки для аренды:', rentalId);
    
    // Находим все активные подписки для данной аренды
    const { data: subscriptions, error: findError } = await supabase
      .from('subscriptions')
      .select('id, status')
      .eq('rental_id', rentalId)
      .in('status', ['active', 'paused']);
      
    if (findError) {
      console.error('Ошибка при поиске подписок:', findError);
      return { 
        success: false, 
        message: `Ошибка при поиске подписок: ${findError.message}` 
      };
    }
    
    console.log(`Найдено ${subscriptions?.length || 0} активных подписок для аренды ${rentalId}`);
    
    if (!subscriptions || subscriptions.length === 0) {
      return { 
        success: true, 
        message: 'Активных подписок для отмены не найдено' 
      };
    }
    
    // Отменяем каждую подписку
    let cancelledCount = 0;
    for (const subscription of subscriptions) {
      const { success, error } = await updateSubscriptionStatus(subscription.id, 'cancelled');
      
      if (success) {
        cancelledCount++;
        console.log(`Подписка ${subscription.id} успешно отменена`);
      } else {
        console.error(`Ошибка при отмене подписки ${subscription.id}:`, error);
      }
    }
    
    return { 
      success: true, 
      message: `Отменено ${cancelledCount} из ${subscriptions.length} подписок` 
    };
  } catch (err: any) {
    console.error('Непредвиденная ошибка при отмене подписок:', err);
    return { 
      success: false, 
      message: `Непредвиденная ошибка: ${err.message}` 
    };
  }
}
